<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>

  <mat-accordion multi="true">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Not scanned 
        </mat-panel-title>
        <mat-panel-description>
          These items need to be scanned
        </mat-panel-description>
      </mat-expansion-panel-header>
      <core-order-item-fulfilment-list [items]="unscannedItems"></core-order-item-fulfilment-list>
    </mat-expansion-panel>
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Scanned 
        </mat-panel-title>
        <mat-panel-description>
          These items have been scanned
        </mat-panel-description>
      </mat-expansion-panel-header>
      <core-order-item-fulfilment-list [items]="scannedItems"></core-order-item-fulfilment-list>
    </mat-expansion-panel>
  </mat-accordion>
  
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>
     <mat-icon>done</mat-icon> Done
 </button>
</div>